import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import { toast } from 'react-toastify';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import { connect } from 'react-redux';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

class AddAccessionSeries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET ACCESSION SERIES
            accessionSeriesList: {},
            loadingAccessionSeriesData: false,

            isAddingAccessionSeries: false,
            isUpdateAccessionSeries: false,
            accessionSeriesText: '',
            isDeleteAccessionSeries: false,
            selectedRow: '',
            currentAccessionSeriesNo: null,
            loadingDeletingData: false,
            accesionSeriesIID: config.institute_id,

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        }
    }

    componentDidMount() {
        if (this.props.iidArray.iidArray?.length > 0) {
            this.apiCallToGetAccessionSeries()
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeriesData: true });

        let requestData = {
            "iid": config.institute_id,
            "iidArray": this.props.iidArray.iidArray
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(seriesId => {
                        apiResult[seriesId]['seriesId'] = seriesId;
                    });
                }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesData.seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId,
                    instituteName: seriesData.instituteName,
                    addedOn:seriesData?.addedOn,
                    added_by_ERP:seriesData?.added_by_ERP,
                    added_by_name:seriesData?.added_by_name,
                    last_updated_by_ERP:seriesData?.last_updated_by_ERP,
                    updatedOn:seriesData?.updatedOn,
                    updated_by_Name:seriesData?.updated_by_Name
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeriesData: false
                });
            }
        }
    }

    closeViewResourceModal = () => {
        this.props.onClose(); // Call parent function directly
    }

    addAccessionSeries = () => {
        this.setState({ isAddingAccessionSeries: true })
    }

    UpdateLibraryAccessionSeries = async (type) => {
        let requestData = {
            'iid': type === 'add' ? this.state.accesionSeriesIID : this.state.selectedRow.iid,  // config.institute_id,
            'text': this.state.accessionSeriesText,
            'facultyId': config.faculty_id,
            'uniqueId': type ? 'add' : this.state.selectedRow.uniqueId
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'UpdateLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.UpdateLibraryAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == "success") {
                    this.setState({ isAddingAccessionSeries: false, accessionSeriesText: '', isUpdateAccessionSeries: false, currentAccessionSeriesNo: null })
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetAccessionSeries()
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while updating resources data. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    DeleteLibraryAccessionSeries = async () => {
        this.setState({ loadingDeletingData: true })

        let requestData = {
            'iid': this.state.selectedRow ? this.state.selectedRow?.iid : config.institute_id,
            'unique_id': this.state.selectedRow.uniqueId,
            'facultyId': config.faculty_id,
            'type': 'location'
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'DeleteLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.DeleteLibraryAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({ isDeleteAccessionSeries: false, selectedRow: '', loadingDeletingData: false })
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == "success") {
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetAccessionSeries()
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                this.setState({ isDeleteAccessionSeries: false, selectedRow: '', loadingDeletingData: false })
                toast.error('Something went wrong while updating resources data. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    deleteAccessionSeriesData = () => {
        return (
            <div className={this.state.isDeleteAccessionSeries ? "modal fade show" : "modal fade"} id="modalContainer">
                <div class="modal-dialog modal-dialog-centered">
                    <div className="modal-content modalBulkContent">
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '20px 25px', backgroundColor: '#c34141', color: ' #ffffff' }}>
                            <h6 className="modal-title">
                                <FontAwesomeIcon size='sm' icon={["fa", "exclamation-triangle"]} style={{ marginRight: '10px' }} />
                                Are you sure?
                            </h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ isDeleteAccessionSeries: false }) }} style={{ cursor: "pointer" }} />
                        </div>

                        <div className="custom-form-body" style={{ padding: '20px 25px' }}>
                            <strong>NOTE:</strong>
                            <ul>
                                <li>All data associated with accession series will be deleted.</li>
                                <li>
                                    You can again add new accession series by clicking on{" "}
                                    <span className="Link" style={{ color: "blue", textDecoration: "underline" }}>
                                        Add accession series Text
                                    </span>
                                </li>
                            </ul>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            <button
                                className="btn delete-primary-button"
                                style={{ fontSize: '14px', borderRadius: '7px' }}
                                onClick={() => { this.setState({ isDeleteAccessionSeries: false }) }}
                            >
                                No
                            </button>
                            <button className="btn delete-outline-button waves-effect" style={{ fontSize: '14px', borderRadius: '7px' }}
                                onClick={() => { this.DeleteLibraryAccessionSeries() }} disabled={this.state.loadingDeletingData}>
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {

        const { accessionSeriesModal } = this.props;

        return (
            <div className={accessionSeriesModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '40VW' }}>
                    <div class="modal-content">
                        {/* modal header data */}
                        <div class="modal-header" style={{ padding: '15px' }}>
                            <h6 class="modal-title text-white" style={{ fontWeight: 500, color: "#000000" }}>Accession Series</h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeViewResourceModal()} style={{ cursor: "pointer" }} />
                        </div>

                        {/* modal content */}
                        <div class="modal-body" style={{ maxHeight: "60vh", height: '75vh', overflowY: 'auto' }}>
                            <div className="d-flex justify-content-end">
                                <button className="btn btn-outline-primary" onClick={() => {
                                    this.addAccessionSeries()
                                }}>
                                    <FontAwesomeIcon size='sm' icon={["fa", "plus"]} /> &nbsp;Add Accession Series Text
                                </button>
                            </div>

                            <div className="table-responsive fixTableHead table_pad mt-2" id='tableResponsive'>
                                <div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                                        <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Sr. No.</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Institute</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Series text</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Last Modified By</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Actions</th>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.loadingAccessionSeriesData ? <tr>
                                                    <td colSpan="3">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                    this.state.accessionSeriesList && this.state.accessionSeriesList.length > 0 ? (
                                                        this.state.accessionSeriesList.map((data, index) => (
                                                            <tr key={data.uniqueId}>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{index + 1}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{data.instituteName}</td>
                                                                {this.state.isUpdateAccessionSeries === true && this.state.currentAccessionSeriesNo === index ?
                                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                                        <div className="input-group input-group-field" style={{ position: 'relative', display: "flex", direction: 'row', alignItems: 'center', gap: '5px' }}>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control formControlAutoTask"
                                                                                placeholder="Enter Accession Series Text"
                                                                                style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: 'auto', fontSize: "13px" }}
                                                                                value={this.state.accessionSeriesText} // Bind value to state
                                                                                onChange={(event) => {
                                                                                    this.setState({
                                                                                        accessionSeriesText: event.target.value || '', // Handle empty selection
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <FontAwesomeIcon icon={['fas', 'check']} size="lg" style={{ cursor: "pointer", marginRight: 5, color: 'green' }} onClick={() => {
                                                                                this.UpdateLibraryAccessionSeries()
                                                                            }} />
                                                                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" style={{ cursor: "pointer", color: 'red' }} onClick={() => {
                                                                                this.setState({ isUpdateAccessionSeries: false, accessionSeriesText: '', currentAccessionSeriesNo: null })
                                                                            }} />
                                                                        </div>

                                                                    </td> :
                                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }} title={data.label}>{data.label.length > 20 ? data.label.slice(0, 20) + '...' : data.label}</td>
                                                                }
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', cursor: "pointer", color: data.uniqueId == this.state.hoverID ? "#0465AC" : "" }}
                                                                    onMouseEnter={() => this.setState({ hoverID: data.uniqueId })}
                                                                    onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                    onClick={() => this.openActivitySlider(data.uniqueId)}>
                                                                    {data.updated_by_Name ? (
                                                                        <div className="d-flex flex-column">
                                                                            <div>{data.updated_by_Name} ({data.last_updated_by_ERP}) | {data.updatedOn}</div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="d-flex flex-column">
                                                                            <div>{data.added_by_name} ({data.added_by_ERP}) | {data.addedOn}</div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', padding: '1.5rem' }}>
                                                                    <FontAwesomeIcon icon={['far', 'edit']} size="lg" title="Click to edit the accession series text" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => {
                                                                        this.setState({ isUpdateAccessionSeries: true, accessionSeriesText: data.label, selectedRow: data, currentAccessionSeriesNo: index })
                                                                    }} />
                                                                    <FontAwesomeIcon icon={['far', 'trash-alt']} size="lg" title="Click to delete the accession series text" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => {
                                                                        this.setState({ isDeleteAccessionSeries: true, selectedRow: data })
                                                                    }} />
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3">No data found.</td>
                                                        </tr>
                                                    )
                                            }
                                            {
                                                this.state.isAddingAccessionSeries &&
                                                <>
                                                    <tr>
                                                        <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}></td>
                                                        <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                            <div className="input-group input-group-field" style={{ position: 'relative', display: "flex", direction: 'row', alignItems: 'center', gap: '5px' }}>
                                                                <select
                                                                    className="form-control formControlContentTask"
                                                                    style={{
                                                                        width: 'auto',
                                                                        height: '42px',
                                                                        fontSize: "13px",
                                                                        fontWeight: 400,
                                                                        lineHeight: '20px',
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        color: '#808080',
                                                                        borderRadius: '7px'
                                                                    }}
                                                                    onChange={(e) => {
                                                                        let selectedIIDValue = e.target.value;
                                                                        this.setState({ accesionSeriesIID: selectedIIDValue })

                                                                    }}
                                                                    value={this.state.accesionSeriesIID} // Bind dropdown value to state
                                                                >
                                                                    {Object.values(this.props?.multipleInstituteDetails?.multipleInstituteDetails).map((member) => (
                                                                        <option key={member?.iid} value={member?.iid}>
                                                                            {member?.institute_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                        </td>
                                                        <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                            <div className="input-group input-group-field" style={{ position: 'relative', display: "flex", direction: 'row', alignItems: 'center', gap: '5px' }}>
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    placeholder="Enter Accession Series Text"
                                                                    style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: 'auto', fontSize: "13px" }}
                                                                    value={this.state.accessionSeriesText} // Bind value to state
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            accessionSeriesText: event.target.value || '', // Handle empty selection
                                                                        });
                                                                    }}
                                                                />
                                                                {/* <FontAwesomeIcon icon={['fas', 'check']} size="lg" style={{ cursor: "pointer", marginRight: 5, color: 'green' }} onClick={() => {
                                                                    this.UpdateLibraryAccessionSeries("add")
                                                                }} />
                                                                <FontAwesomeIcon icon={['fas', 'times']} size="lg" style={{ cursor: "pointer", color: 'red' }} onClick={() => {
                                                                    this.setState({ isAddingAccessionSeries: false })
                                                                }} /> */}
                                                            </div>
                                                        </td>
                                                        <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', padding: '1.5rem' }}>
                                                            <FontAwesomeIcon icon={['fas', 'check']} size="lg" style={{ cursor: "pointer", marginRight: 5, color: 'green' }} onClick={() => {
                                                                this.UpdateLibraryAccessionSeries("add")
                                                            }} />
                                                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" style={{ cursor: "pointer", color: 'red' }} onClick={() => {
                                                                this.setState({ isAddingAccessionSeries: false })
                                                            }} />
                                                        </td>
                                                    </tr>
                                                </>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.deleteAccessionSeriesData()
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["AccessionSeries_added", "accessionSeries_deleted", "AccessionSeries_updated"]}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }

    };
};

export default connect(mapStateToProps)(AddAccessionSeries);
// export default AddAccessionSeries;